import api from './api';

export interface Permission {
  id: number;
  name: string;
  description: string;
}

export interface Role {
  id: number;
  name: string;
  description: string;
  permissions: Permission[];
  created_at: string;
  updated_at: string;
}

export interface CreateRoleRequest {
  name: string;
  description: string;
  permissionIds: number[];
}

export interface UpdateRoleRequest {
  name?: string;
  description?: string;
  permissionIds?: number[];
}

export const roleService = {
  // Get all roles
  getRoles: async (): Promise<Role[]> => {
    const response = await api.get('/roles');
    return response.data;
  },

  // Get single role by ID
  getRole: async (id: number): Promise<Role> => {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  },

  // Create new role
  createRole: async (data: CreateRoleRequest): Promise<Role> => {
    const response = await api.post('/roles', data);
    return response.data;
  },

  // Update role
  updateRole: async (id: number, data: UpdateRoleRequest): Promise<Role> => {
    const response = await api.put(`/roles/${id}`, data);
    return response.data;
  },

  // Delete role
  deleteRole: async (id: number): Promise<void> => {
    await api.delete(`/roles/${id}`);
  },

  // Get all available permissions
  getPermissions: async (): Promise<Permission[]> => {
    const response = await api.get('/permissions');
    return response.data;
  },
};

// Types are already exported above